import React, { Component } from 'react';
import { Plus, Minus } from '../../common/icons';

class QuantityControls extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        return (
            <div className="quantity-container">
                <h4 style={{ color: this.props.color ? this.props.color : null }}>Quantity</h4>
                <div className="quantity-counter-container">
                    <div className="quantity-counter-button" onClick={() => this.props.handleQuantityCount('neg')}>
                        <Minus />
                    </div>
                    <input type='text' className="quantity-counter-input" name="quantity_counter" value={this.props.quantity_counter} onChange={(e) => this.props.handleQuantityInput(e)} />
                    <div className="quantity-counter-button" onClick={() => this.props.handleQuantityCount('pos')}>
                        <Plus />
                    </div>
                </div>
            </div>
        )
    }
}

export default QuantityControls;


// WEBPACK FOOTER //
// ./src/components/new-order/card/quantity-controls.jsx